"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useColumnsFromColumnsDef = useColumnsFromColumnsDef;
exports.useRowSelect = useRowSelect;
exports.useTableState = useTableState;
exports.useUpdateContextOnPropChanges = useUpdateContextOnPropChanges;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _react = require("react");

var _actions = require("./actions");

var _utils = require("./utils");

var _context = require("./context");

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty2(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty2(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function useColumnsFromColumnsDef(columnsDef, responsive) {
  return (0, _react.useMemo)(function () {
    if (!columnsDef) {
      return {
        columns: []
      };
    }

    var columns = (0, _utils.flattenColumns)(columnsDef, responsive);
    var maxHeaderCount = (0, _utils.getMaxHeaderCount)(columns);

    if (responsive) {
      columns = (0, _map["default"])(columns).call(columns, function (column) {
        return _objectSpread(_objectSpread({}, column), {}, {
          width: 0
        });
      });
    }

    return {
      columns: columns,
      maxHeaderCount: maxHeaderCount
    };
  }, [columnsDef, responsive]);
}

function useUpdateContextOnPropChanges(fireAction, props, contextValue) {
  var controlSelection = contextValue.controlSelection,
      selectedRows = contextValue.selectedRows,
      selectedRow = contextValue.selectedRow,
      uniqueDataKey = contextValue.uniqueDataKey,
      data = contextValue.data;
  (0, _react.useEffect)(function () {
    fireAction((0, _actions.updateStateValues)(_objectSpread({}, props))); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fireAction, props.tableId, props.responsive, props.children, props.data, props.width, props.height, props.uniqueDataKey, props.onSelectAll, props.onRowClick, props.getSelectionInputTooltip, props.getRowClassName, props.hideHeader, props.fixSelectionColumn, props.noCheckboxTable, props.isExpandable, props.isSelectable, props.multiSelect, props.disabledRows, props.onRowSelectionChange, props.isLoading, props.isLoadingMore, props.loadingMoreText, props.onLoadMore, props.loadedAll, props.rowRenderer, props.emptyRenderer, props.footerRenderer, props.footerHeight, props.estimatedRowHeight, props.enableFullScreen, props.exportToCsv, props.csvFileName, props.sortBy, props.sortOrder, props.onSort, props.exportPopupMaxHeight, props.defaultExpandedRows, props.expandedRows, props.onRowExpand, props.enableCSVToastMessage]);
  (0, _react.useEffect)(function () {
    var allRowIds = data ? (0, _map["default"])(data).call(data, function (obj) {
      return obj[uniqueDataKey];
    }) : [];

    if (!controlSelection && selectedRows.length > 0) {
      var currentRows = (0, _filter["default"])(selectedRows).call(selectedRows, function (rowId) {
        return (0, _includes["default"])(allRowIds).call(allRowIds, rowId);
      });

      if (selectedRows.length !== currentRows.length) {
        fireAction((0, _actions.setSelectedRows)(currentRows));
      }
    }

    if (!controlSelection && selectedRow !== null && !(0, _includes["default"])(allRowIds).call(allRowIds, selectedRow)) {
      (0, _actions.selectSingleRow)(null);
    }
  }, [data, controlSelection, selectedRows, selectedRow, uniqueDataKey, fireAction]);
}

function useRowSelect(_ref, _ref2) {
  var fireAction = _ref.fireAction,
      stateSelectedRows = _ref.selectedRows,
      stateSelectedRow = _ref.selectedRow;
  var onRowSelectionChange = _ref2.onRowSelectionChange,
      noCheckboxTable = _ref2.noCheckboxTable,
      multiSelect = _ref2.multiSelect,
      selectedRows = _ref2.selectedRows;
  (0, _react.useEffect)(function () {
    var selectionState = {
      controlSelection: !!selectedRows
    };

    if (selectedRows) {
      if (multiSelect) {
        selectionState.selectedRows = selectedRows;
      } else {
        selectionState.selectedRow = selectedRows[0] || null;
      }
    }

    fireAction((0, _actions.updateStateValues)(selectionState));
  }, [fireAction, selectedRows, multiSelect]);
  (0, _react.useEffect)(function () {
    if ((0, _utils.isFunction)(onRowSelectionChange) && !noCheckboxTable) {
      onRowSelectionChange(multiSelect ? stateSelectedRows : stateSelectedRow);
    }
  }, [onRowSelectionChange, noCheckboxTable, multiSelect, stateSelectedRows, stateSelectedRow]);
}

function useTableState() {
  var _useTable = (0, _context.useTable)(),
      selectedRows = _useTable.selectedRows,
      disabledRows = _useTable.disabledRows,
      data = _useTable.data,
      uniqueDataKey = _useTable.uniqueDataKey,
      selectedRow = _useTable.selectedRow;

  var totalRows = data.length;
  var selectedRowIds = selectedRows;
  var totalSelectedRows = selectedRows.length;
  var disabledRowIds = disabledRows;
  var totalDisabledRows = disabledRows.length;

  var _useMemo = (0, _react.useMemo)(function () {
    /* eslint-disable */
    var selectedRowItems = [];
    var disabledRowItems = [];
    var unSelectedRowIds = [];
    var unSelectedRowItems = [];
    var selectedRowItem = null;
    /* eslint-enable */

    (0, _forEach["default"])(data).call(data, function (record) {
      var id = record[uniqueDataKey];

      if (!(0, _includes["default"])(selectedRows).call(selectedRows, id)) {
        unSelectedRowIds.push(id);
        unSelectedRowItems.push(record);
      } else {
        selectedRowItems.push(record);
      }

      if ((0, _includes["default"])(disabledRows).call(disabledRows, id)) {
        disabledRowItems.push(record);
      }

      if (id === selectedRow) {
        selectedRowItem = record;
      }
    });
    return {
      selectedRowItems: selectedRowItems,
      disabledRowItems: disabledRowItems,
      unSelectedRowIds: unSelectedRowIds,
      unSelectedRowItems: unSelectedRowItems,
      selectedRowItem: selectedRowItem,
      totalUnselectedRows: unSelectedRowIds.length
    };
  }, [data, disabledRows, selectedRows, uniqueDataKey, selectedRow]),
      unSelectedRowIds = _useMemo.unSelectedRowIds,
      unSelectedRowItems = _useMemo.unSelectedRowItems,
      selectedRowItems = _useMemo.selectedRowItems,
      disabledRowItems = _useMemo.disabledRowItems,
      totalUnselectedRows = _useMemo.totalUnselectedRows,
      selectedRowItem = _useMemo.selectedRowItem;

  return {
    totalRows: totalRows,
    selectedRowId: selectedRow,
    selectedRowItem: selectedRowItem,
    selectedRowIds: selectedRowIds,
    selectedRowItems: selectedRowItems,
    totalSelectedRows: totalSelectedRows,
    disabledRowIds: disabledRowIds,
    disabledRowItems: disabledRowItems,
    totalDisabledRows: totalDisabledRows,
    unSelectedRowIds: unSelectedRowIds,
    unSelectedRowItems: unSelectedRowItems,
    totalUnselectedRows: totalUnselectedRows
  };
}